function n(e) {
  return e.map(u);
}
function u(e) {
  var l, r;
  return typeof e == "string" ? {
    label: e,
    value: e
  } : e.type === "group" ? {
    type: "group",
    label: (l = e.label) !== null && l !== void 0 ? l : e.name,
    value: (r = e.value) !== null && r !== void 0 ? r : e.name,
    key: e.key || e.name,
    children: e.children.map((a) => u(a))
  } : e;
}
export {
  n as mapAutoCompleteOptionsToSelectOptions
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/auto-complete/src/utils.js
// module id = 1634
// module chunks = 67